export const draftBailiffAllSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffAll;
export const draftBailiffOpenAddSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffOpenAdd;
export const draftBailiffOpenEditSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffOpenEdit;
export const draftBailiffSelectedSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffSelected;
export const draftBailiffSearchSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffSearch;

//
export const draftBailiffDetailSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffDetail;
export const draftBailiffOpenForwardSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffOpenForward;
export const draftBailiffMergeSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffMerge;
export const draftBailiffSpeakerSelector = (state) =>
  state?.draftBailiffReducer?.draftBailiffSpeakers;

//
